/**
 * Get the full URL for a storage path
 * Handles both local and production environments correctly
 */
export function getStorageUrl(path: string | null | undefined): string | null {
    if (!path) return null;

    // If path is already a full URL, return it
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    // Get base URL from environment
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

    // Remove /api suffix to get the base domain
    const baseUrl = apiUrl.replace(/\/api\/?$/, '');

    // Remove leading slash from path if present
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Construct full storage URL
    return `${baseUrl}/storage/${cleanPath}`;
}

/**
 * Get avatar URL for a user
 */
export function getAvatarUrl(user: { avatar?: string | null; updated_at?: string | null } | null | undefined): string | null {
    if (!user?.avatar) return null;
    const url = getStorageUrl(user.avatar);
    if (!url || !user.updated_at) return url;

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${encodeURIComponent(user.updated_at)}`;
}
